<script lang="ts" setup>
import { Popup, showLoadingToast } from "vant";
import MagicStickIcon from "@/components/icon/MagicStickIcon.vue";
import { useRouter } from "vue-router";
import RabbitIcon from "@/components/icon/RabbitIcon.vue";
import MediaSelectPopup from "@/components/mobile/media/MediaSelectPopup.vue";
import { ref } from "vue";
import { MediaUploadFileItem } from "@/types/component";
import VideoIcon from "@/components/icon/VideoIcon.vue";
import { useTask } from "@/stores/task";
import PicPlus from "@/components/icon/PicPlus.vue";
import i18n from "@/locales";

const props = defineProps<{
  show: boolean;
}>();
const emit = defineEmits<{
  (e: "update:show", value: boolean): void;
}>();

const task = useTask();
const router = useRouter();
const imgList = ref<MediaUploadFileItem[]>([]);
const showMediaSelection = ref(false);
const cropAspectRatio = ref(3 / 4);

const onCropAspectRatioChange = (value: string) => {
  const [width, height] = value.split(":").map((v) => parseInt(v));
  cropAspectRatio.value = width / height;
};

// Event Handler
const onMediaSelected = async (mediaList: MediaUploadFileItem[]) => {
  const loading = showLoadingToast({
    message: i18n.global.t("Message.creatingDynamicPictureTask"),
  });
  try {
    const media = mediaList[0];
    let param: Parameters<typeof task.createGifTask>[0] = {
      sourceId: media.mediaId,
    };
    if (media.textImage) {
      const { prompt, mateTraitId, style } = media.textImage;
      param = {
        ...param,
        prompt,
        mateTraitId: mateTraitId ?? undefined,
        style: style > 0 ? style : undefined,
      };
    }
    await task.createGifTask(param);
    imgList.value = [];
    emit("update:show", false);
    showMediaSelection.value = false;
    router.push({ name: "imageGenerateList", hash: "#unfinished" });
  } finally {
    loading.close();
  }
};

const showCreateImageModeModal = ref(false);
const showCreateTraitPresetModal = ref(false);
</script>
<template>
  <popup
    :show="show"
    class="w-[350px] py-10"
    position="center"
    round
    @update:show="emit('update:show', $event)"
  >
    <div class="flex flex-col items-center justify-center w-full h-full gap-4">
      <div class="flex flex-col items-center justify-center gap-2">
        <div class="text-lg font-bold">
          {{ $t("task.createAIGenerationTask") }}
        </div>
      </div>
      <div class="flex flex-col gap-2">
        <button
          class="w-60 btn rounded btn-sm btn-primary"
          @click="showCreateImageModeModal = true"
        >
          <magic-stick-icon class="icon-base" />
          {{ $t("task.tab.TextImage") }}
        </button>
        <button
          class="w-60 btn rounded btn-sm btn-primary"
          @click="showCreateTraitPresetModal = true"
        >
          <i class="iconfont icon-emoji"></i>
          {{ $t("task.tab.MateTrait") }}
        </button>
        <!-- <button
          class="w-60 btn rounded btn-sm btn-primary "
          @click="showMediaSelection = true"
        >
          <rabbit-icon class="icon-base" />
          {{ $t("task.tab.TextGif") }}
        </button>
        <button
          class="w-60 btn rounded btn-sm btn-primary "
          @click="router.push({ name: 'videoGeneration' })"
        >
          <video-icon class="icon-base" />
          {{ $t("task.tab.StoryVideo") }}
        </button> -->
        <!-- <button
          class="w-60 btn rounded btn-sm btn-primary "
          @click="router.push({ name: 'multipleImageMerge' })"
        >
          <i class="iconify mingcute--pic-line" />
          {{ $t("task.tab.CreateMultiuserImage") }}
        </button> -->
        <button
          class="btn w-60 rounded btn-sm"
          @click="emit('update:show', false)"
        >
          {{ $t("Buttons.close") }}
        </button>
      </div>
    </div>
  </popup>
  <media-select-popup
    v-model:media-list="imgList"
    v-model:show="showMediaSelection"
    :crop-aspect-ratio="cropAspectRatio"
    :enable-go-image-gen="false"
    :max-count="1"
    :multiple="false"
    :upload-type="7"
    enable-crop
    enable-use-avatar
    media-type="img"
    replace
    show-ratio-select
    @update:crop-aspect-ratio="onCropAspectRatioChange"
    @on-media-selected="onMediaSelected"
  />

  <create-image-mode-modal v-model:show="showCreateImageModeModal" />
  <create-trait-preset-modal v-model:show="showCreateTraitPresetModal" />
</template>
